import { Step } from "react-joyride";
import { VisibilityStates } from "../../types/VisibilityStates";

export const tourStepsDiscoverCollections = (
  visibilityStates: VisibilityStates,
): Step[] => {
  const steps: Step[] = [
    {
      target: ".discover-collections-page",
      content:
        "Discover Collections shows public collections from other users. You can preview one and add a copy to Your Collections.",
      disableBeacon: true,
    },
    {
      target: ".search-collections-input",
      content:
        "Search by collection name, creator, or category. All public collections stay in one list.",
      ...(visibilityStates.isSearchInputVisible ? { isOpen: true } : {}),
    },
    {
      target: "#discoverMasteryStageSelect",
      content:
        "My stage filters public collections the same way as Your Collections. Beginner shows only Beginner-tagged decks, and so on. Show all reveals every public collection. Switch when you are ready for the next group.",
    },
    {
      target: ".discover-category-filters",
      content:
        "Filter by subject so you only see math, letters, or another category.",
      ...(visibilityStates.isCategorySelectVisible ? { isOpen: true } : {}),
    },
    {
      target: "#sortSelect",
      content:
        "Change the sort to browse by date, name, or another order. Section headings follow this sort.",
      ...(visibilityStates.isSortSelectVisible ? { isOpen: true } : {}),
    },
    {
      target: ".grid",
      content:
        "Each card is a public collection. Open a preview to see the items before you add it to Your Collections.",
      ...(visibilityStates.isCollectionsGridVisible ? { isOpen: true } : {}),
    },
    {
      target: ".preview-collection-button",
      content:
        "Preview shows the items. Add to My Collections puts a copy on Your Collections so you can practice it.",
      ...(visibilityStates.isPreviewButtonVisible ? { isOpen: true } : {}),
    },
    {
      target: ".collection-preview-modal",
      content:
        "Review the items here, then add it if you want this collection. It will appear on Your Collections as a copy.",
      ...(visibilityStates.isCollectionPreviewModalVisible
        ? { isOpen: true }
        : {}),
    },
  ];

  return steps.filter((step) => {
    if (step.target === ".search-collections-input")
      return visibilityStates.isSearchInputVisible;
    if (step.target === ".discover-category-filters")
      return visibilityStates.isCategorySelectVisible;
    if (step.target === "#sortSelect")
      return visibilityStates.isSortSelectVisible;
    if (step.target === ".grid")
      return visibilityStates.isCollectionsGridVisible;
    if (step.target === ".preview-collection-button")
      return visibilityStates.isPreviewButtonVisible;
    if (step.target === ".collection-preview-modal")
      return visibilityStates.isCollectionPreviewModalVisible;
    return true;
  });
};
